//Color palette
export const COLOR_PALETTE = {
  red: { name: 'Red', value: '#ef4444', description: 'Bold and energetic' },
  orange: { name: 'Orange', value: '#f97316', description: 'Creative and warm' },
  yellow: { name: 'Yellow', value: '#eab308', description: 'Bright and optimistic' },
  green: { name: 'Green', value: '#22c55e', description: 'Natural and balanced' },
  blue: { name: 'Blue', value: '#3b82f6', description: 'Calm and reliable' },
  purple: { name: 'Purple', value: '#a855f7', description: 'Imaginative and unique' },
  pink: { name: 'Pink', value: '#ec4899', description: 'Playful and friendly' },
  teal: { name: 'Teal', value: '#14b8a6', description: 'Peaceful and refreshing' },
  indigo: { name: 'Indigo', value: '#6366f1', description: 'Deep and thoughtful' },
  lime: { name: 'Lime', value: '#84cc16', description: 'Fresh and lively' },
  emerald: { name: 'Emerald', value: '#10b981', description: 'Growth and harmony' },
  sky: { name: 'Sky', value: '#0ea5e9', description: 'Open and free' }
} as const;

//Vals
export const COLOR_VALUES = {
  red: '#ef4444',
  orange: '#f97316', 
  yellow: '#eab308',
  green: '#22c55e',
  blue: '#3b82f6',
  purple: '#a855f7',
  pink: '#ec4899',
  teal: '#14b8a6',
  indigo: '#6366f1',
  lime: '#84cc16',
  emerald: '#10b981',
  sky: '#0ea5e9'
} as const;

//Type defs
export type ColorKey = keyof typeof COLOR_PALETTE;
export type ColorValue = typeof COLOR_VALUES[ColorKey];

//Default color ToDo: Choose a default
export const DEFAULT_COLOR_KEY: ColorKey = 'blue';
export const DEFAULT_COLOR_VALUE = COLOR_VALUES[DEFAULT_COLOR_KEY];

//Utility functions
export const getColorValue = (colorKey: string | undefined | null): string => {
  if (!colorKey) return DEFAULT_COLOR_VALUE;
  return COLOR_VALUES[colorKey as ColorKey] || DEFAULT_COLOR_VALUE;
};

export const getColorInfo = (colorKey: string | undefined | null) => {
  if (!colorKey) return COLOR_PALETTE[DEFAULT_COLOR_KEY];
  return COLOR_PALETTE[colorKey as ColorKey] || COLOR_PALETTE[DEFAULT_COLOR_KEY];
};

//Hash function for consistent color assignment (used for fallbacks)
export const hashString = (str: string): number => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; //Convert to 32-bit int
  }
  return Math.abs(hash);
};

//Get a consistent color for a user ID (fallback when no preference set)
export const getHashedColorForUser = (userId: string): string => {
  const hash = hashString(userId);
  const colors = Object.values(COLOR_VALUES);
  return colors[hash % colors.length];
};

//Array, if necessary
export const COLOR_KEYS = Object.keys(COLOR_PALETTE) as ColorKey[];